export const MAIL_CONTENT_CHARS_LIMIT = 10000;
